import store from '@/vuex/store'

const router = [
  {
    path: '/auth',
    redirect: '/login',
    component: () => import('@/modules/Auth/layout'),
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('@/modules/Auth/pages/login')
      },
      {
        path: '/logout',
        name: 'logout',
        component: () => import('@/modules/Auth/pages/logout'),
        meta: {
          requiresAuth: true
        }
      },
      {
        path: '/firstLogin',
        name: 'firstLogin',
        component: () => import('@/modules/Auth/pages/firstLogin'),
        meta: {
          requiresAuth: true,
          requiresPermission: false
        }
      },
      {
        path: '/forgotPassword',
        name: 'forgotPassword',
        component: () => import('@/modules/Auth/pages/forgotPassword')
      },
      {
        path: '/resetPassword/:token',
        name: 'resetPassword',
        component: () => import('@/modules/Auth/pages/resetPassword'),
        beforeEnter: async (to, from, next) => {
          try {
            await store.dispatch('clearState')
            const subdomain = location.hostname.split('.')[0]
            await store.dispatch('auth/getFileLoginCustom', subdomain)
          } catch (e) {
            // undefined error
          }
          next()
        }
      },
      {
        path: '/userBlock',
        name: 'userBlock',
        component: () => import('@/modules/Auth/components/authLoginUserBlock'),
        meta: {
          requiresAuth: true,
          requiresPermission: false
        }
      },

      {
        path: '/checkingAccountKeyCloak/:code?',
        name: 'checkingAccountKeyCloak',
        component: () => import('@/modules/Auth/components/falabella'),
      },

      {
        path: '/passwordExpired',
        name: 'passwordExpired',
        component: () => import('@/modules/Auth/pages/passwordExpired'),
        meta: {
          requiresAuth: true,
          requiresPermission: false
        }
      },
      {
        path: '/mfa/',
        redirect: '/login',
        name: 'Mfa',
        component: () => import('@/modules/Auth/pages/mfa'),
        children: [
          {
            path: 'emailVerification',
            name: 'mfaEmailVerification',
            component: () =>
              import('@/modules/Auth/pages/mfa/emailVerification'),
            meta: {
              requiresAuth: true,
              requiresPermission: false
            }
          },
          {
            path: 'codeVerification',
            name: 'mfaCodeVerification',
            component: () =>
              import('@/modules/Auth/pages/mfa/codeVerification'),
            meta: {
              requiresAuth: true,
              requiresPermission: false
            }
          },
          {
            path: 'userBlock',
            name: 'mfaUserBlock',
            component: () => import('@/modules/Auth/pages/mfa/userBlock'),
            meta: {
              requiresAuth: true,
              requiresPermission: false
            }
          }
        ]
      }
    ],
    beforeEnter: async (to, from, next) => {
      try {
        // No limpiar estado si venimos de keyCloak o authSSO o vamos a keyCloak
        if (from.name !== 'authSSO' && to.name !== 'logout' && to.name !== 'keyCloak' && from.name !== 'keyCloak') {
          await store.dispatch('clearState')
        }
        const subdomain = location.hostname.split('.')[0]
        await store.dispatch('auth/getFileLoginCustom', subdomain)
        const { ssoToken } = to.query
        if (ssoToken) {
          to.query.ssoToken = ''
          await redirectAuthSSO(next, ssoToken)
        } else {
          next()
        }
      } catch (e) {
        // undefined error
      }
      next()
    }
  },
  {
    path: '/redirect/authSSO/:token',
    name: 'authSSO',
    component: () => import('@/modules/Auth/pages/middlewareAuth/authSSO')
  },
  {
    path: '/redirect/authSAML',
    name: 'authSAML',
    component: () =>
      import('@/modules/Auth/pages/middlewareAuth/SAML/authSAML'),
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/idp/SingleLogoutService',
    name: 'singleLogoutSAML',
    component: () =>
      import('@/modules/Auth/pages/middlewareAuth/SAML/logoutSAML')
  },
  {
    path: '/mobile',
    name: 'mobileLogin',
    redirect: '/mobile/login',
    component: () => import('@/modules/Auth/layout'),
    children: [
      {
        path: '/mobile/login',
        name: 'mobileLoginAction',
        component: () => import('@/modules/Auth/pages/login')
      }
    ]
  },
  {
    path: '/mobile/success',
    name: 'mobileLoginSuccess',
    component: () => import('@/modules/Auth/pages/mobile/Success'),
    meta: {
      requiresAuth: true
    }
  }
]
const redirectAuthSSO = (next, ssoToken) => {
  try {
    next({ name: 'authSSO', params: { ssoToken: ssoToken } })
  } catch (e) {
    next()
  }
}

export default router
